export const moduleId = "consolidated-income-tax-statement";
import api from './../../../api/consolidated-income-tax-statement/incomeWrite/index'
import UserPersistence from './../../../persistence/UserPersistence'
import {setMessage} from '../../../libs/message';

export const state = {


  params: {
    sourceCode: null, //	登录唯一标识
    abId: null, //账套id（所属机构）
    year: null, //所属年度
    month: null, ////所属月份
    operator: null
  },
  stepName: 'first',
  writeIncomeFlag: "",//
  selectedRow: {},//
  //收入及减除项填写
  salaryDialog: false,//薪资 和劳务报酬弹窗新增
  salaryTitleFlag: "add",// 工资 和劳务报酬新增   修改
  //收入减除项填写 与税款计算共用
  paymentBonusDialog: false,  // 稿酬所得和全年一次性奖金 弹窗
  paymentBonusFlag: "add",//稿酬所得和全年一次性奖金 新增和编辑标识
  paymentBonusData: null,// 稿酬所得和全年一次性奖金详情
  //税款计算
  taxcelDialog: false,//税款计算 劳务报酬弹窗
  salaryDetailDialog: false, //税款计算工资弹窗
  salarydetailData: null,//工资详情
  labourDetailData: null,
  titleName: "",
  totalTaxData: {},//
  //特权使用费所得
  privilegeDialog: false,
  privilegeFlag: '',


};

export const actions = {
  //收入及减除填写查询

  async queryTotalTax({state, commit, dispatch}) {
    let query = {
      ...state.params,

    }
    let res = await api.totalTax(query)
    if (!res.code) {
      commit('setTotalTax', res.data);

    } else {
      setMessage({type: "error", message: res.msg})
    }
  },


};

export const mutations = {
  setPrivilegeDialog(state, data) {
    state.privilegeDialog = data
  },
  setPrivilegeFlag(state, data) {
    state.privilegeFlag = data
  },
  setWriteIncomeFlag(state, falg) {
    state.writeIncomeFlag = falg
  },
  setSelectedRow(state, row) {
    state.selectedRow = row
  },
  setStepName(state, falg) {
    state.stepName = falg
  },
  setPaymentBonusDialog(state, falg) {
    state.paymentBonusDialog = falg

  },
  setParams(state, params) {
    state.params.year = params.year,
      state.params.month = params.month
    state.params.sourceCode = params.sourceCode,
      state.params.abId = params.abId,
      state.params.operator = params.operator

  },

  setsalaryDialog(state, falg) {
    state.salaryDialog = falg
  },
  setSalaryTitleFlag(state, falg) {
    state.salaryTitleFlag = falg

  },
  setPaymentBonusData(state, data) {
    state.paymentBonusData = data

  },
  setPaymentBonusFlag(state, falg) {
    state.paymentBonusFlag = falg

  },

  //工资详情
  setSalaryDetailData(state, data) {
    state.salarydetailData = data

  },
  setTitleName(state, data) {
    state.titleName = data

  },
  setLabourDetailData(state, data) {
    state.labourDetailData = data

  },
  setTotalTax(state, data) {
    state.totalTaxData = data
  },

  setDetailDialog(state, data) {
    if (data.type === 'salary') {
      state.salaryDetailDialog = data.flag
    } else if (data.type === 'taxcel') {
      state.taxcelDialog = data.flag

    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/consolidated-income-tax-statement/index.js